<template>
  <div class="card-container" :class="{'article-recommended-style': articleRecommendedPlace}">
    <router-link v-if="item.link !== undefined" :to="openPlace(item.link)">
      <div class="image-block">
        <img
          class="h-100 w-100 object-fit-cover card-image"
          loading="lazy"
          :src="item.imageSrc"
          :alt="item.imageAlt"
        >
        <div v-t="'generic.card.more_details.label'" class="more-info-text" />
        <div v-if="item.isFeatured" v-t="'place_card.popular.label'" class="popular-badge" />
      </div>
      <div class="info-block w-100" :class="{'article-place-info-block': articleRecommendedPlace}">
        <div
          class="place-city d-flex"
          :class="{'order-2': articleRecommendedPlace}"
          v-text="!articleRecommendedPlace ? item.city : item.city + ', ' + item.address + ', ' + item.zipCode"
        />
        <div class="place-name" :class="{'order-1': articleRecommendedPlace}">
          <div class="name" v-text="item.name" />
          <rating-stars
            v-if="item.numberOfStars !== null"
            class="ms-2"
            :rating="item.numberOfStars"
            :is-public-mode="true"
          />
        </div>
        <div class="place-desc d-flex" :class="{'order-3': articleRecommendedPlace}" v-text="item.desc" />
        <div v-if="!articleRecommendedPlace" class="d-flex mb-4 align-items-end h-100 icon-block">
          <div
            data-bs-toggle="tooltip"
            class="d-flex justify-content-start align-items-center"
            :data-bs-title="$t('place.number_of_rooms')"
          >
            <img class="icon" :src="ICON_MEETING_ROOM">
            <span class="icon-title" v-text="item.numberOfRooms + getPieceText('place.piece')" />
          </div>
          <div
            data-bs-toggle="tooltip"
            class="d-flex justify-content-start align-items-center"
            :data-bs-title="$t('place.number_of_event_halls')"
          >
            <img class="icon" :src="ICON_PODIUM">
            <span class="icon-title" v-text="item.numberOfEventHalls + getPieceText('place.piece')" />
          </div>
          <div
            data-bs-toggle="tooltip"
            class="d-flex justify-content-start align-items-center"
            :data-bs-title="$t('place.maximum_capacity')"
          >
            <img class="icon" :src="ICON_PEOPLE_ALT">
            <span class="icon-title" v-text="item.maxCapacity + getPieceText('place.people')" />
          </div>
        </div>
      </div>
    </router-link>
    <RequestBtnAndFavoriteIconRow v-if="!articleRecommendedPlace" class="w-100 pb-3 px-5" :place="item" />
  </div>
</template>

<script>
import RatingStars from '@shared/components/rating-stars/RatingStars.vue'
import ICON_MEETING_ROOM from '@/../public/assets/place-card-icons/meeting_room.png'
import ICON_PEOPLE_ALT from '@/../public/assets/place-card-icons/people_alt.png'
import ICON_PODIUM from '@/../public/assets/place-card-icons/podium.png'
import pageName from '@/constants/pageName.js'
import RequestBtnAndFavoriteIconRow from '@/components/requerst-btn-and-favorite-icon-row/RequestBtnAndFavoriteIconRow.vue'
import { useRuntimeEnvironment } from '@shared/components/runtime-environment/RuntimeEnvironment.js'

export default {
  name: 'PlaceCard',
  components: {
    RequestBtnAndFavoriteIconRow,
    RatingStars,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    /**
     * Cikkhez kapcsolt helyszin, eltérő design vonatkozik rá.
     */
    articleRecommendedPlace: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ICON_MEETING_ROOM,
      ICON_PEOPLE_ALT,
      ICON_PODIUM,
      pageName: pageName,
    }
  },
  methods: {
    /**
     * Chh ki kell írni a nyelvikulcs értékét.
     * @param {string} text
     * @returns {string}
     */
    getPieceText(text) {
      if (useRuntimeEnvironment().isCHH()) {
        return ' ' + this.$t(text)
      }

      return ''
    },
    /**
     * link megnyitása.
     * Belső linkekről van szó ezért a domaint az levágjuk az elejéről.
     *
     * @param {string} link
     */
    openPlace(link) {
      if (link.includes(window.location.origin)) {
        return link.replace(window.location.origin, '')
      }
      return link
    },
  },
}
</script>

<style lang="scss" scoped>
// router-link miatt, kikapcsoljuk a default <a> tag aláhuzást
a {
  text-decoration: none;
  color: #000;
}

.card-container {
  width: 100%;
  border-radius: 0.25rem;
  background: #fff;
  box-shadow: 0 0.125rem 0.25rem -0.063rem rgba(0, 0, 0, 0.06), 0 0.25rem 0.375rem -0.063rem rgba(0, 0, 0, 0.10);
  cursor: pointer;
}

.article-recommended-style {
  background: #efefef;
  box-shadow: none;
}

.more-info-text {
  visibility: hidden;
  font-size: 0.813rem;
  font-weight: 600;
  line-height: 1rem;
  text-align: left;
  color: #fff;
  text-transform: uppercase;
}

.image-block {
  height: 10rem;
  position: relative;

  .card-image {
    border-top-left-radius: 0.25rem;
    border-top-right-radius: 0.25rem;
  }

  .popular-badge {
    display: flex;
    width: 7.063rem;
    padding: 0.313rem 0.625rem;
    justify-content: center;
    align-items: center;
    gap: 0.625rem;
    background-color: var(--main-theme-color);
    position: absolute;
    top: 0;
    text-transform: uppercase;
    font-size: 0.813rem;
    font-weight: 600;
    line-height: 1rem;
    color: #fff;
    border-top-left-radius: 0.25rem;
  }

  .icon {
    color: #bfbfbf;
  }

  .icon-title {
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1.0625rem;
    text-align: left;
  }
}

.card-container:hover {
  .name {
    text-decoration: underline;
  }

  .more-info-text {
    visibility: visible;
    position: absolute;
    top: 50%;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  .card-image {
    filter: brightness(50%);
  }
}

.info-block {
  height: 19rem;
  padding: 0.938rem 1.25rem 0.625rem 1.25rem;
  display: flex;
  flex-direction: column;

  .place-city {
    color: #707070;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 0.313rem;
  }

  .place-name {
    display: flex;
    align-items: flex-start;
    align-content: flex-start;
    align-self: stretch;
    flex-wrap: wrap;
    margin-bottom: 0.625rem;

    .name {
      color: #000;
      font-size: 1.313rem;
      font-style: normal;
      font-weight: 700;
      line-height: 1.688rem;
      text-align: left;
    }
  }

  .place-desc {
    color: #000;
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 400;
    line-height: 1.25rem;
    text-align: left;
    font-family: Inter ,serif;
  }
}

.article-place-info-block {
  padding: 0.938rem 0 0.625rem 0;
}

.icon-block {
  column-gap: 1.875rem;
  max-height: 100%;
}
</style>
